import { Combinator, DataTypeSearchCombo, GenericDataType } from 'modules/domains';

import { ElementType, useElementIndex } from '../../contexts';
import { useCriteriaState } from '../useCriteriaState';

const DEFAULT_REQUIREMENT = {
  dataType: GenericDataType.User,
  searchCombo: { combinator: Combinator.AND, searchQueries: [] },
};

export const useRequirement = (): DataTypeSearchCombo => {
  const [{ searchQueries }] = useCriteriaState();
  const requirementIndex = useElementIndex(ElementType.Requirement);
  const requirement = searchQueries[requirementIndex];
  if (requirement && 'dataType' in requirement) return requirement;
  return DEFAULT_REQUIREMENT;
};
